import { observer } from 'mobx-react';
import { useState } from 'react';

interface IPodcastPlayer {
	audioFilePath: string;
	videoFilePath: string;
	title?: string;
}

export const PodcastPlayer = observer((props: IPodcastPlayer) => {
	const [activeMode, setActiveMode] = useState<'audio' | 'video'>('audio');

	return (
		<div className="podcast-player-container margin-top-1rem">
			<div className="buttons has-addons" style={{ marginBottom: '1rem' }}>
				<button className={`button ${activeMode === 'audio' ? 'is-info is-selected' : ''}`} onClick={() => setActiveMode('audio')}>
					Audio
				</button>
				<button className={`button ${activeMode === 'video' ? 'is-info is-selected' : ''}`} onClick={() => setActiveMode('video')}>
					Video
				</button>
			</div>

			<div className={`podcast-player ${activeMode === 'video' ? 'is-video' : 'is-audio'}`}>
				{activeMode === 'audio' && (
					<>
						{props.title && (
							<div className="podcast-poster">
								<h3 className="is-size-3">{props.title}</h3>
							</div>
						)}
						<audio controls controlsList="nodownload" src={props.audioFilePath} style={{ width: '100%' }} />
					</>
				)}

				{activeMode === 'video' && (
					<video width="100%" controls controlsList="nodownload">
						<source src={props.videoFilePath} type="video/mp4" />
						Your browser does not support the video tag.
					</video>
				)}
			</div>
		</div>
	);
});
